/* PDP Desktop In-Place Image Zoom */
(function() {
  if (window.innerWidth < 750) return;

  function findMedia(target) {
    return target.querySelector('.media')
        || target.querySelector('img')?.parentElement
        || target.firstElementChild;
  }

  function handleZoomClick(e) {
    var target = e.target.closest('.product__gallery-zoom-target');
    if (!target) return;

    var media = findMedia(target);
    if (!media) return;

    if (target.classList.contains('is-zoomed')) {
      target.classList.remove('is-zoomed');
      media.style.transform = '';
      media.style.transformOrigin = '';
      if (target._panHandler) {
        target.removeEventListener('mousemove', target._panHandler);
        target._panHandler = null;
      }
    } else {
      target.classList.add('is-zoomed');
      var rect = target.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      media.style.transformOrigin = x + '% ' + y + '%';
      media.style.transform = 'scale(2)';

      target._panHandler = function(ev) {
        var r = target.getBoundingClientRect();
        var px = ((ev.clientX - r.left) / r.width) * 100;
        var py = ((ev.clientY - r.top) / r.height) * 100;
        media.style.transformOrigin = px + '% ' + py + '%';
      };
      target.addEventListener('mousemove', target._panHandler);
    }
  }

  function handleZoomLeave(e) {
    var target = e.target.closest('.product__gallery-zoom-target');
    if (!target || !target.classList.contains('is-zoomed')) return;
    var related = e.relatedTarget;
    if (related && target.contains(related)) return;

    var media = findMedia(target);
    target.classList.remove('is-zoomed');
    if (media) {
      media.style.transform = '';
      media.style.transformOrigin = '';
    }
    if (target._panHandler) {
      target.removeEventListener('mousemove', target._panHandler);
      target._panHandler = null;
    }
  }

  document.addEventListener('click', handleZoomClick);
  document.addEventListener('mouseout', handleZoomLeave);
})();

/* Size Chart in/cm toggle */
(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.size-chart__toggle-btn');
    if (!btn) return;

    var chart = btn.closest('.size-chart');
    if (!chart) return;

    var unit = btn.classList.contains('size-chart__toggle-btn--cm') ? 'cm' : 'in';

    chart.querySelectorAll('.size-chart__toggle-btn').forEach(function(b) {
      b.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    chart.querySelectorAll('.unit-in').forEach(function(el) {
      el.style.display = unit === 'in' ? 'inline' : 'none';
    });
    chart.querySelectorAll('.unit-cm').forEach(function(el) {
      el.style.display = unit === 'cm' ? 'inline' : 'none';
    });
  });
})();
